import FormAttachedFile from 'components/common/forms/FormAttachedFile';
import FileList from 'components/common/lists/FileList';
import FormAutoHeightTextarea from 'components/common/forms/FormAutoHeightTextarea';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { TChartFileInfoList } from 'types/chart';
import { OralHealthEducationDataChartFields } from 'constants/chart/oralHealthEducationDataChart';

type TProps = {
  fileInfoList: TChartFileInfoList[];
  attachmentFiles: File[];
  setAttachmentFiles: (files: File[]) => void;
  deleteFileIdList: number[];
  setDeleteFileIdList: (deleteFileIdList: number[]) => void;
  isRegister: boolean;
  isReadOnly: boolean;
};

const OralHealthEducationData = ({
  fileInfoList,
  attachmentFiles,
  setAttachmentFiles,
  deleteFileIdList,
  setDeleteFileIdList,
  isRegister,
  isReadOnly,
}: TProps) => {
  return (
    <>
      <div className="mt56">
        <FormAutoHeightTextarea
          name={OralHealthEducationDataChartFields.educationText}
          readOnly={!isRegister || isReadOnly}
          placeholder="텍스트를 입력해 주세요."
          textareaStyle={{
            width: '100%',
            minHeight: '240px',
            border: `1px solid ${STYLES_VARIABLES.GRAY_03}`,
            borderRadius: '8px',
            padding: '12px 16px',
            marginLeft: '0',
          }}
        />
      </div>
      {isRegister && !isReadOnly ? (
        <FormAttachedFile
          name="uploadFile"
          files={attachmentFiles}
          inputId="uploadFile"
          accept="ppt, docx, pdf, mp4"
          btnIcon="plus"
          btnText="자료 업로드하기"
          btnStyle={{
            position: 'absolute',
            top: '0',
            right: '0',
            lineHeight: '40px',
            fontSize: '16px',
          }}
          onDelete={(index) =>
            setDeleteFileIdList([...deleteFileIdList, index])
          }
          onChange={(files) => setAttachmentFiles(files)}
        />
      ) : (
        attachmentFiles?.length > 0 && (
          <FileList
            value={fileInfoList || []}
            listStyle={{
              marginTop: '16px',
            }}
          />
        )
      )}
    </>
  );
};

export default OralHealthEducationData;
